import { render, staticRenderFns } from "./CPUpdateDetailsReminder.vue?vue&type=template&id=0f45f026&scoped=true&"
import script from "./CPUpdateDetailsReminder.vue?vue&type=script&lang=ts&"
export * from "./CPUpdateDetailsReminder.vue?vue&type=script&lang=ts&"
import style0 from "./CPUpdateDetailsReminder.vue?vue&type=style&index=0&id=0f45f026&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f45f026",
  null
  
)

export default component.exports